import React from 'react';
import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import BookList from './components/BookList';
import AddBook from './components/AddBook';
import EditBook from './components/EditBook';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState } from 'react';

function App() {
  const [searchQuery, setSearchQuery] = useState('');
  const [isFeaturedSelected, setIsFeaturedSelected] = useState(false);

  const handleFeatured = () => {
    setIsFeaturedSelected(!isFeaturedSelected);
  }
  return (
    <Router>
      <body>
        <Navbar setSearchQuery={setSearchQuery} searchQuery={searchQuery} />
        <main class="py-12 px-6 2xl:px-6 container">
          <div class="order-2 xl:-order-1">
            <div class="flex items-center justify-between mb-12">
              <h4 class="mt-2 text-xl font-bold">Book List</h4>

              <div class="flex items-center space-x-4">
                <button className={isFeaturedSelected ? "lws-filter-btn" : "lws-filter-btn active-filter"} onClick={handleFeatured}>All</button>
                <button className={isFeaturedSelected ? "lws-filter-btn active-filter" : "lws-filter-btn"} onClick={handleFeatured}>Featured</button>
              </div>
            </div>
            <Routes>

              <Route path="/" element={<BookList searchQuery={searchQuery} isFeaturedSelected={isFeaturedSelected} />}></Route>
              <Route path="/create" element={<AddBook />}></Route>
              <Route path="/edit/:bookId" element={<EditBook />} />
            </Routes>
          </div>
        </main>
      </body>
    </Router>);
}

export default App;
